import React from 'react';
import PropTypes from 'prop-types';
import { getNoDataMessage } from './utils';

const NoDataMessage = ({
  hasVendors,
  hasProductsWithVendors,
}) => (
  <div className="c-table-no-data">
    {getNoDataMessage(hasVendors, hasProductsWithVendors)}
  </div>
);

NoDataMessage.propTypes = {
  hasVendors: PropTypes.bool.isRequired,
  hasProductsWithVendors: PropTypes.bool.isRequired,
};

export default NoDataMessage;
